import React, { useState } from 'react';
import { Container, Typography, Box, ToggleButtonGroup, ToggleButton, Tooltip, Paper } from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CategoryIcon from '@mui/icons-material/Category';
import ListAltIcon from '@mui/icons-material/ListAlt';
import TimelineIcon from '@mui/icons-material/Timeline';
import PositionsTable from './PositionsTable';
import PositionsByTypeTable from './PositionsByTypeTable'
import PositionsByInstrumentTypeTable from './PositionsByInstrumentTypeTable'
import InstrumentEvolutionChart from './InstrumentEvolutionChart'
import { LAYOUT } from '../../constants/layout';
import { useCurrency } from '../../contexts/CurrencyContext';
import { isFeatureEnabled, FEATURE_FLAGS } from '../../utils/featureFlags';

const PositionsPage = () => {
  const [dashboardType, setDashboardType] = useState('instrument');
  const { currency: currencyView } = useCurrency();

  const getTitle = () => {
    switch (dashboardType) {
      case 'class': return 'Consolidação por Classe';
      case 'instrument': return 'Consolidação por Instrumento';
      case 'evolution': return 'Evolução por Classe de Ativo';
      default: return 'Consolidação por Ativo';
    }
  };

  return (
    <Container maxWidth={false} disableGutters sx={LAYOUT.PAGE_SPACING}>
      <Typography variant="h4" align="center" gutterBottom>
        {getTitle()}
      </Typography>

      <Paper sx={{ p: 2, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', bgcolor: 'action.hover', borderRadius: 1, p: 0.5 }}>
            <ToggleButtonGroup
              value={dashboardType}
              exclusive
              onChange={(_, newType) => newType && setDashboardType(newType)}
              size="small"
              sx={{
                '& .MuiToggleButton-root': {
                  border: 'none',
                  borderRadius: 1,
                  px: 1.5,
                  gap: 0.5,
                  '&.Mui-selected': {
                    bgcolor: 'background.paper',
                    boxShadow: 1,
                  },
                },
              }}
            >
              <Tooltip title="Consolidação por Classe">
                <ToggleButton value="class">
                  <AccountBalanceIcon fontSize="small" />
                  Por Classe
                </ToggleButton>
              </Tooltip>
              <Tooltip title="Consolidação por Instrumento">
                <ToggleButton value="instrument">
                  <CategoryIcon fontSize="small" />
                  Por Instrumento
                </ToggleButton>
              </Tooltip>
              <Tooltip title="Consolidação por Ativo">
                <ToggleButton value="assets">
                  <ListAltIcon fontSize="small" />
                  Por Ativo
                </ToggleButton>
              </Tooltip>
              {isFeatureEnabled(FEATURE_FLAGS.POSITION_EVOLUTION_CHART) && (
                <Tooltip title="Evolução por Classe de Ativo">
                  <ToggleButton value="evolution">
                    <TimelineIcon fontSize="small" />
                    Evolução
                  </ToggleButton>
                </Tooltip>
              )}
            </ToggleButtonGroup>
          </Box>
        </Box>
      </Paper>

      {dashboardType === 'class' && <PositionsByTypeTable currencyView={currencyView} />}
      {dashboardType === 'instrument' && <PositionsByInstrumentTypeTable currencyView={currencyView} />}
      {dashboardType === 'assets' && <PositionsTable currencyView={currencyView} />}
      {dashboardType === 'evolution' && isFeatureEnabled(FEATURE_FLAGS.POSITION_EVOLUTION_CHART) && <InstrumentEvolutionChart currencyView={currencyView} />}
    </Container>
  );
};

export default PositionsPage;
